// extracted by mini-css-extract-plugin
export default {"bold":"PromotionRow__bold-R6JbK","apps":"PromotionRow__apps-jh0zo","normal":"PromotionRow__normal-RLvHo"};